import { render, staticRenderFns } from "./Alunos.vue?vue&type=template&id=f20b01b0"
import script from "./Alunos.vue?vue&type=script&lang=js"
export * from "./Alunos.vue?vue&type=script&lang=js"
import style0 from "./Alunos.vue?vue&type=style&index=0&id=f20b01b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports